import { jsx } from "react/jsx-runtime";
import Crehana from "@crehana/icons/logos/Crehana";
import CrehanaLive from "@crehana/icons/logos/CrehanaLive";
import CrehanaMicroDegree from "@crehana/icons/logos/CrehanaMicroDegree";
import CrehanaPremium from "@crehana/icons/logos/CrehanaPremium";
import FutureOfPeople from "@crehana/icons/logos/FutureOfPeople";
import { colors } from "@crehana/ui";
import clsx from "clsx";
import useOrganizationTheme from "../../../hooks/useOrganizationTheme/index.js";
import OrganizationLogoImage from "./components/OrganizationLogoImage.js";
import { useMainMenuContext } from "../../hooks/index.js";
import { LOGO_WRAPPER_CLASSNAME } from "./constants.js";
const Logo = ({ targetLink = '_self' })=>{
    const { themeName, theme, urls, me, logoType: logoTypeProp, layoutConfig, handleLogoClick } = useMainMenuContext();
    const { customSizeLogo = 32 } = layoutConfig;
    const organizationSlug = me?.organization?.slug || '';
    const { data, loading } = useOrganizationTheme(organizationSlug, {
        skip: !me.isB2B
    });
    const defaultLogoType = me.isB2B ? 'b2b' : 'default';
    const logoType = logoTypeProp || defaultLogoType;
    const { hideLeftLogo = false } = layoutConfig || {};
    const isDark = 'dark' === themeName.nav;
    const renderLogo = (logoClassName)=>{
        if ('b2b' === logoType) {
            const imageAlt = data?.name || me.organization?.name || 'Crehana for Business';
            const logoImage = (isDark ? data?.configuration?.darkModeLogo : data?.logo) || data?.logo || '';
            const lookAndFeel = data?.lookAndFeel;
            return /*#__PURE__*/ jsx(OrganizationLogoImage, {
                src: logoImage,
                alt: imageAlt,
                customSizeLogo: customSizeLogo,
                className: logoClassName,
                colors: {
                    primary: lookAndFeel?.primary?.main || theme.nav.logo.color,
                    secondary: lookAndFeel?.primary?.main || theme.nav.logo.secondaryColor
                }
            });
        }
        if ('premium' === logoType) return /*#__PURE__*/ jsx(CrehanaPremium, {
            size: customSizeLogo || 32,
            "aria-hidden": true,
            color: theme.nav.logo.color,
            secondaryColor: theme.nav.logo.secondaryColor,
            className: logoClassName
        });
        if ('microdegree' === logoType) return /*#__PURE__*/ jsx(CrehanaMicroDegree, {
            size: customSizeLogo || 24,
            "aria-hidden": true,
            color: theme.nav.logo.color,
            secondaryColor: theme.nav.logo.secondaryColor,
            className: logoClassName
        });
        if ('live' === logoType) return /*#__PURE__*/ jsx(CrehanaLive, {
            size: customSizeLogo || 32,
            "aria-hidden": true,
            color: theme.nav.logo.color,
            secondaryColor: theme.nav.logo.secondaryColor,
            className: logoClassName
        });
        if ('blog' === logoType) return /*#__PURE__*/ jsx(FutureOfPeople, {
            size: 18,
            "aria-hidden": true,
            color: colors.baseMain,
            className: logoClassName
        });
        return /*#__PURE__*/ jsx(Crehana, {
            size: 16,
            "aria-hidden": true,
            color: theme.nav.logo.color,
            className: logoClassName
        });
    };
    if (hideLeftLogo || loading) return null;
    if (layoutConfig.disableLogoRedirection) return renderLogo(LOGO_WRAPPER_CLASSNAME);
    return /*#__PURE__*/ jsx("a", {
        id: "main-menu-logo",
        href: urls.home,
        onClick: handleLogoClick,
        className: clsx('flex items-center', !layoutConfig.newSidebarEnabled && LOGO_WRAPPER_CLASSNAME, layoutConfig.leftLogoWrapperClassNames || '', layoutConfig.newSidebarEnabled && 'mr-auto'),
        css: `
        ${layoutConfig.newSidebarEnabled ? 'width: 256px; margin-left: -63px; justify-content: center; flex-shrink: 0;' : ''}
      `,
        "aria-label": me.organization?.name || 'Crehana',
        target: targetLink,
        children: renderLogo()
    });
};
const Logo_Logo = Logo;
export default Logo_Logo;
